module.exports = "<fihe-filter-box></fihe-filter-box>\n<fihe-result-box></fihe-result-box>\n<fihe-filter-map></fihe-filter-map>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-view/main-view.component.html
// module id = ./src/app/main-view/main-view.component.html
// module chunks = main